import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const MoodBannerVideo = ({ blok }) => {
  

  return (
    <div  className="banner-video relative flex items-center justify-center"{...storyblokEditable(blok)}>
      <div className="banner-video-desktop" style={{padding:`42.55% 0 0 0`, position: `relative`, width: `100vw`, height: `100vh`}}>
        <iframe
              style={{ display: `${blok.hideVideo}` }}
              className="textimage-iframe-mobile"
              src={blok.video}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="PA_Akquisefilm V22"
        ></iframe>
      </div>
      {blok.videoMobile && (
      <div className="banner-video-mobile" style={{padding:`42.55% 0 0 0`, position: `relative`, width: `100vw`, height: `100vh`}}>
        <iframe suppressHydrationWarning={true}
              style={{ display: `${blok.hideVideo}` }}
              className="textimage-iframe-mobile"
              src={blok.videoMobile}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="PA_Akquisefilm V22"
        ></iframe>
      </div>
      )}
      <div style={{ display: `${blok.hideContent}` }} className="banner-content absolute flex items-center">
        <div className="banner-textcontent flex flex-col justify-center items-center">
          <h1 className="text-5xl bold font-bold">{blok.headline}</h1>
          <span className="text-center">{blok.content}</span>
          <div className="flex">
            <Link href={blok.link} ><button>{blok.button}</button></Link>
          </div>
        </div>
      </div>
    </div>


  );};

export default MoodBannerVideo;
